import {JapaneseVerb} from "../types";
import {StyledTable} from "../../../../../common/components/StyledTable";
import {Box} from "@mui/material";


export interface JapaneseVerbConjugationViewProps {
    verbInfo: JapaneseVerb
}

interface conjugationRow {
    form: string;
    conjugation: (verbInfo: JapaneseVerb) => string;
}

const CONJUGATION_ROWS: conjugationRow[] = [
    {"form": 'Negative', conjugation: (v) => v.negative},
    {"form": 'Masu', conjugation: (v) => v.masu},
    {"form": 'Past', conjugation: (v) => v.past},
    {"form": 'Te-form', conjugation: (v) => v.te_form},
    {"form": 'Potential', conjugation: (v) => v.potential},
    {"form": 'Volitional', conjugation: (v) => v.volitional},
    {"form": 'Causative', conjugation: (v) => v.causative},
    {"form": 'Conditional', conjugation: (v) => v.conditional},
    {"form": 'Passive', conjugation: (v) => v.passive}
]

export function JapaneseVernConjugationView({verbInfo}: JapaneseVerbConjugationViewProps) {

    return (
        <Box mt={1}>
            <StyledTable
                columns={[
                    {key: "key", header: "Form", render: (row) => row.form},
                    {key: "value", header: "Conjugation", render: (row) => row.conjugation(verbInfo)}
                ]}
                rows={CONJUGATION_ROWS}
                getRowKey={(row, index) => index}
            />
        </Box>
    )
}
